import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { PriceA11y } from "src/components/flexComponents/Hotels/utils/A11y/priceA11yInterface";
import { DATE_FORMAT } from "src/components/flexComponents/Hotels/utils/constants";
import { Hotel } from "src/typings/microserviceModels/hotels-flex-module";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";

interface UitkPriceLockupProps {
  hotel: Hotel;
  align?: UitkPriceLockupAlign;
  className?: string;
  priceA11y?: PriceA11y;
  strikeThroughPrice?: string;
}

export const PriceLockupDefault = ({
  className,
  hotel,
  priceA11y,
  strikeThroughPrice,
  align,
}: UitkPriceLockupProps) => {
  const { formattedPrice: lockupPrice, isoCheckIn, isoCheckOut } = hotel;

  const { formatText, formatDateString } = useLocalization();

  const checkInDateFormatted = formatDateString(isoCheckIn, { skeleton: DATE_FORMAT });
  const checkOutDateFormatted = formatDateString(isoCheckOut, { skeleton: DATE_FORMAT });

  const props = {
    lockupPrice,
    priceSubtextFirst: formatText("hotels.price.perNight"),
    priceSubtextStandard: formatText("hotels.whenBooking", checkInDateFormatted, checkOutDateFormatted),
    a11yPrice: priceA11y?.getA11yText() || "",
    strikeThroughPrice,
    align,
    className,
  };

  return <UitkPriceLockup {...props} />;
};

export default PriceLockupDefault;
